
import { computed, defineComponent, reactive, ref, watch } from "vue";
import moment from "moment";
import { useStore } from "vuex";
import { listNaikPangkatBorangPublic } from "@/apollo/dashboard/kenaikanPangkat";
import { useQuery } from "@vue/apollo-composable";
import MyAxios from "@/core/helpers/axios_helper";

const DashboardKenaikanPangkatPemohon = defineComponent({
  name: "dashboard-pergerakan-pegawai",
  data(vm) {
    return {
      permohonanSaya: [] as any[],
    };
  },
  mounted() {
    (async()=>{
      try{
        let req = await MyAxios.get('/api/pengguna/perjawatan/naik-pangkat-mohon');
        this.permohonanSaya = req.data;
      }
      catch(ex){
        console.log('DashboardKenaikanPangkatPemohon :: mounted :: exception', ex);
      }
    })();
  },
  setup() {
    const store = useStore();

    const filter = reactive({
      type: null,
    });

    const list = reactive({
      status_borang: "",
      permohonanDitutup: 0,
      permohonanDibuka: 0,
      permohonanBelumDibuka: 0,
    });

    const search = ref("");

    const { result } = useQuery(listNaikPangkatBorangPublic, null, {
      fetchPolicy: "no-cache",
    });

    const naikPangkatBorangList = computed(() => {
      const promotions = result.value?.naikPangkatBorangListPublic ?? [];

      let clone = JSON.parse(JSON.stringify(promotions));
      // Filter only iklan "BARU" "BUKA" and "AKTIF" to be displayed at Pengguna > Perkhidmatan
      // Define allowed statuses
      // clone = clone.filter((promotion) => promotion.status == "BARU" || promotion.status == "AKTIF");
      const allowedStatuses = ["BARU", "AKTIF", "BUKA"];

      // Filter based on allowed statuses
      clone = clone.filter((promotion) =>
        allowedStatuses.includes(promotion.status?.toUpperCase())
      );
      if (filter.type) {
        clone = clone.filter(
          (promotion) => promotion.kategori_permohonan == filter.type
        );
      }

      console.log("clone", clone);

      return clone;
    });

    watch(naikPangkatBorangList, () => {
      list.permohonanBelumDibuka = naikPangkatBorangList.value.filter(
        (item) => item.status == "BARU" || item.status == ""
      ).length;
      
      list.permohonanDibuka = naikPangkatBorangList.value.filter(
        (item) => item.status == "BUKA" || item.status == "AKTIF"
      ).length;
      
      list.permohonanDitutup = naikPangkatBorangList.value.filter(
        (item) =>
          item.status == "SEMAKAN" ||
          item.status == "MENUNGGU_KEPUTUSAN" ||
          item.status == "TIDAK AKTIF" ||
          item.status == "SELESAI"
      ).length;
    });

    const statusLabel = (status) => {
      switch (status) {
        case "BARU":
          return "Baharu";
        case "AKTIF":
          return "Dibuka";
        case "BUKA":
          return "Dibuka";
        case "SEMAKAN":
          return "Ditutup";
        case "MENUNGGU_KEPUTUSAN":
          return "Ditutup";
        case "SELESAI":
          return "Ditutup";
        case "TIDAK AKTIF":
          return "Ditutup";
        default:
          return "Belum Dibuka";
      }
    };

    const formatDate = (date) => {
      moment.locale("ms");
      return moment(date).format("DD MMMM YYYY");
    };

    const getPromotionType = (type) => {
      switch (type) {
        case "KNP":
          return "KENAIKAN PANGKAT";
        case "PMK":
          return "PEMANGKUAN";
        default:
          return "";
      }
    };

    const getLabelClass = (type) => {
      switch (type) {
        case "KNP":
          return "pertukaran";
        default:
          return "";
      }
    };

    const isAuthenticated = () => {
      return store.getters.isUserAuthenticated ? true : false;
    };

    return {
      filter,
      formatDate,
      getLabelClass,
      getPromotionType,
      naikPangkatBorangList,
      search,
      statusLabel,
      list,
      isAuthenticated,
    };
  },
});

export default DashboardKenaikanPangkatPemohon;
